import React from 'react';

//Componentes
import GuiaSearchContainer from '../../components/guiaSearch/GuiaSearchContainer';
import { formatNumber } from '../../helpers';

//Estilos
import './SearchGuias.css';

function SearchGuia({ functions, states }) {
    const {
        register,
        handleSubmit,
        formState: { errors },
        onSearch,
    } = functions;

    const { masters, SearchParameters } = states;

    return (
        <div className="search_guia-container">
            <section className="search_guia-section">
                <h4>Filtro de Búsqueda de Guías</h4>
                <form
                    className="search_guia-search_form"
                    onSubmit={handleSubmit(onSearch)}
                >
                    <label className="search_guia-label">
                        <span>Titular: </span>
                        <input
                            className="search_guia-input"
                            type="text"
                            {...register('titular')}
                        />
                    </label>
                    <label className="search_guia-label">
                        <span>Titular Destinatario: </span>
                        <input
                            className="search_guia-input"
                            type="text"
                            {...register('titular_Destinatario')}
                        />
                    </label>
                    <label className="search_guia-label">
                        <span>Serie: </span>
                        <input
                            type="number"
                            {...register('serie')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 20
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="search_guia-label">
                        <span>Estado: </span>
                        <select {...register('estado')}>
                            {masters?.GuiaStateTypes?.sort(
                                (a, b) => a.id - b.id
                            ).map((gst) => {
                                return (
                                    <option key={gst.id} value={gst.id}>
                                        {gst.nombre}
                                    </option>
                                );
                            })}
                        </select>
                    </label>
                    <label className="search_guia-label">
                        <span>Viñedo: </span>
                        <input
                            type="number"
                            {...register('viniedo')}
                            onKeyPress={(e) => {
                                if (
                                    !/[0-9]/.test(e.key) ||
                                    e.target.value.length > 15
                                ) {
                                    e.preventDefault();
                                }
                            }}
                        />
                    </label>
                    <label className="new_guia-destinos-label">
                        <div className="new-guia-destinos-div">
                            <span>Destino: </span>
                            <div>
                                {masters?.Destinos?.map((d, i) => {
                                    return (
                                        <label
                                            className="new-guia-detino-label"
                                            key={`destino${i}`}
                                        >
                                            <input
                                                {...register(`destino[${i}]`)}
                                                type="checkbox"
                                                defaultChecked={false}
                                                value={d.id}
                                            />
                                            {d.nombre.replaceAll('_', ' ')}
                                        </label>
                                    );
                                })}
                            </div>
                        </div>
                    </label>
                    <div className="search_guia-form-footer">
                        <button className="btn btn-primary" type="submit">
                            Buscar
                        </button>
                    </div>
                </form>
            </section>
            {Object.keys(SearchParameters.guias).length > 0 && (
                <GuiaSearchContainer />
            )}
        </div>
    );
}

export default SearchGuia;
